import { ShiftKomaModel } from '../vo/shift-koma.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * コマ入替コマンド
 *
 * @export
 * @class ShiftKomaService
 * @extends {PlessResponderSub}
 */
@Injectable()
export class ShiftKomaService extends PlessJsonResponderSub<any> {

  /** 処理に使用するModel */
  private vo: ShiftKomaModel = null;
  private successFunction: Function = null;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof ShiftKomaService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      update: {
        Koma: {
          parameter: {
            OrderCode: this.vo.orderCode,
            MediumType: this.vo.mediumType,
            CoopCode: this.vo.coopCode,
            PageNum: this.vo.pageNum,
            KomaIDFr: this.vo.komaIDFr,
            KomaIDTo: this.vo.komaIDTo,
            SizeW: this.vo.sizeW,
            SizeH: this.vo.sizeH
          }
        }
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param {ShiftKomaModel} vo パラメータ
   * @param {Function} successFunction 成功時後続処理
   * @memberof ShiftKomaService
   */
  execute(vo: ShiftKomaModel, successFunction: Function) {
    this.vo = vo;
    this.successFunction = successFunction;
    this.send('KYMW14shiftKoma', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} _ レスポンスデータ
   * @memberof ShiftKomaService
   */
  success(_: any) {
    // リクエスト成功時コマページ更新
    this.successFunction();
  }
}
